'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isPromise = require('../utils/isPromise');

var _isPromise2 = _interopRequireDefault(_isPromise);

var _systemLoading = require('../actions/systemLoading');

var _systemError = require('../actions/systemError');

var _promiseCounter = require('./promiseCounter');

var _promiseCounter2 = _interopRequireDefault(_promiseCounter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _systemShowLoading(dispatch) {
  if (_promiseCounter2.default.isEmpty()) {
    dispatch((0, _systemLoading.systemShowLoading)());
  }

  _promiseCounter2.default.countUp();
}

function _systemHideLoading(dispatch) {
  // make sure the count down the PromiseCounter in another event loop
  // to handle we chain the ajax call.
  setTimeout(function () {
    _promiseCounter2.default.countDown();

    // if there is no promise, we relase the loading bar
    if (_promiseCounter2.default.isEmpty()) {
      dispatch((0, _systemLoading.systemHideLoading)());
    }
  });
}

exports.default = function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return function (next) {
    return function (action) {
      // We wish all actions follow the FSA standard.
      if (!action.payload) {
        return next(action);
      }
      var promise = action.payload.promise || action.payload;
      if (!(0, _isPromise2.default)(promise)) {
        return next(action);
      }

      var ignoreSystemLoading = false;
      var handlers = null;

      if (action.meta) {
        ignoreSystemLoading = !!action.meta.ignoreSystemLoading;
        handlers = action.meta.handlers;
      }

      if (!ignoreSystemLoading) {
        _systemShowLoading(dispatch);
      }

      (0, _systemError.systemCleanError)();

      return promise.then(function (result) {
        if (!ignoreSystemLoading) {
          _systemHideLoading(dispatch);
        }

        if (handlers) {
          if (handlers.success) {
            handlers.success(dispatch, getState, result);
          }

          if (handlers.finally) {
            handlers.finally(dispatch, getState);
          }
        }

        dispatch(_extends({}, action, {
          payload: result
        }));
      }).catch(function (error) {
        if (!ignoreSystemLoading) {
          _systemHideLoading(dispatch);
        }

        if (handlers) {
          if (handlers.failed) {
            handlers.failed(dispatch, getState, error);
          }

          if (handlers.finally) {
            handlers.finally(dispatch, getState);
          }
        }

        dispatch(_extends({}, action, {
          payload: error,
          error: true
        }));

        throw error;
      });
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/kryfe-lib/es/middlewares/promiseMiddleware.js
// module id = DNaW
// module chunks = 4